import BooleanDetailsFormRow from "../../../Common/DetailsForm/Presenter/BooleanDetailsFormRow";
import DetailsFormRow from "../../../Common/DetailsForm/Presenter/DetailsFormRow";
import { Link } from "react-router-dom";
import { viewModel } from "./viewModel";

export function DetailsPresenter(props: { object: viewModel }) {
  return (
    <>
      <div className="-app-display-section">
        <h2>Dane podstawowe</h2>
        <BooleanDetailsFormRow
          label="Zgoda"
          value={props.object.consent}
        ></BooleanDetailsFormRow>
        {props.object.consent && (
          <>
            <DetailsFormRow
              label="E-mail1"
              value={props.object.eMail1}
            ></DetailsFormRow>
            <DetailsFormRow
              label="E-mail2"
              value={props.object.eMail2}
            ></DetailsFormRow>
          </>
        )}
        {props.object.consent || (
          <div className="row mb-3">
            <div className="col-sm-8 offset-sm-4">
              <div className="alert alert-warning" role="alert">
                <div className="mb-3">
                  <h2>
                    <i className="bi bi-exclamation-diamond text-warning me-2"></i>{" "}
                    Brak zgody na e-faktury
                  </h2>
                </div>
                <div>
                  <p>
                    Nie wyraziłeś jeszcze zgody na otrzymywanie faktur drogą
                    elektroniczną.
                  </p>
                  <p>
                    <Link
                      to="./../Edit?backUrl=../index"
                      className="alert-link"
                    >
                      Wyrażenie zgody na otrzymywanie e-faktur
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default DetailsPresenter;
